import React, { useEffect, useRef, useState } from 'react';
import "./ResultPageLast.css";
import blog from "../../images/result.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import { END_URL, IMG_URL, ASSET_URL } from "../../config";
import buttonloader from "../../images/buttonloader.gif";
import Subscriptions from "../Subscriptions/Subscriptions";
import axios from "axios";

function ResultPageLast({ payment, token,demension,onLoginChange ,type ,TestLink ,userdetail}) {

    const [ButtonLoad, setButtonLoad] = useState(false);

      let subImage, subContent, subButton, subButtonLink;

        if (type === 'special_quiz') {

            subImage = demension?.test_sub_image;
            subContent = demension?.sub_content;
            subButton = demension?.test_sub_button;
            subButtonLink = demension?.test_sub_button_link;

        } 
        else if(type === 'result')
        {
        
            subImage = demension?.sub_image;
            subContent = demension?.paid_sub_content;
            subButton = demension?.paid_test_sub_button;
            subButtonLink = demension?.paid_test_sub_button_link;

        }
        else if(type === 'free_result')
        {
        
            subImage = demension?.dimension_sub_image;
            subContent = demension?.sub_content_free;
            subButton = demension?.test_sub_button_free;
            subButtonLink = demension?.test_sub_button_link_free;

        }

    const Price = payment?.price;


    const subS= true;

    const [subscription, setSubscription] = useState(null);

    const [ShowModal, setShowModal] = useState(false);

    const LoginShow = () => {

        window.scrollTo({ top: 0, behavior: 'smooth' });
        onLoginChange(true); 
    };

    const LoginShowSub = (subids) => {

        if (subids) {
            try {
            let parsedSubIds;

            if (typeof subids === "string") {
                try {
                parsedSubIds = JSON.parse(subids);
                } catch {
                parsedSubIds = [subids];
                }
            } else if (Array.isArray(subids)) {
                parsedSubIds = subids;
            } else {
                parsedSubIds = [subids];
            }

            localStorage.setItem("pendingSubIds", JSON.stringify(parsedSubIds));
            } catch (error) {
            console.error("Failed to save subids to localStorage:", error);
            }
        }
        window.scrollTo({ top: 0, behavior: "smooth" });
        onLoginChange(true);
    };

    const handleNavigete = (link) => {

        if (link) {
        window.location.href = `/${link}`;
        }
    };

    const handleSub = async (subJson) => {

        try {

            setShowModal(true);

            let subIds = subJson;

            if (typeof subJson === "string") {
            try {
                subIds = JSON.parse(subJson);
            } catch (e) {
                console.error("Invalid JSON string for subIds:", e);
                return;
            }
            }

            if (!Array.isArray(subIds) || subIds.length === 0) {
            console.warn("No valid subscription IDs found:", subIds);
            return;
            }

            const res = await axios.post(
            `${END_URL}/sub_adver`,
            { ids: subIds },
            {
                headers: {
                Authorization: `Bearer ${token}`,
                },
            }
            );

            setSubscription(res.data);

        } catch (err) {

            console.error("Error loading subscriptions:", err);
        }
    };

    console.log(subscription,'subscription');

    // const HandlePayment = (item) => {
    //     const InitializePayment = async () => {
    //         try {

    //             setButtonLoad(true);

    //             const response = await fetch(`${END_URL}/test-payment`, {
    //                 method: "POST",
    //                 headers: {
    //                     Authorization: `Bearer ${token}`,
    //                     "Content-Type": "application/json",
    //                 },
    //                 body: JSON.stringify(item)
    //             });
    //             const data = await response.json();
    //             console.log(data.payment, 'fetch data');
    //             if (data.payment) {

    //                 setButtonLoad(false);
    //                 window.location.href = data.payment;
    //             } else {

    //                 setButtonLoad(false);

    //                 console.error("Invalid response:", data);
    //                 alert("An error occurred while processing the request.");
    //             }
    //         } catch (error) {
    //             console.error("Error sending result:", error);
    //         }
    //     };
    //     InitializePayment();
    // };

    // const handleUpgradeClick = (e) => {
    //     e.preventDefault();
    //     HandlePayment(payment);
    // };

    return (

    subImage && (

        <>
        <div className='result-last'>
            <div className="container">
                <div className="row result-last-row">
                    <div className="col-12 col-sm-6 col-md-6">

                        {subImage &&(
                            <div className="res-last-img">

                            <img src={`${IMG_URL}/d0/${subImage}`}  alt={demension?.imagealt} />

                            </div>
                        )}

                    </div>
                    <div className="col-12 col-sm-6 col-md-6">

                        <div className="res-last-div-text">
                          
                          <div dangerouslySetInnerHTML={{ __html: subContent }} />

                            <div className="row rest-last-row-btns">
                                <div className="rest-last-btns rest-buttons">


                            {token ? (
                                <a
                                    className="home-slider-sun-box-a"

                                    // href={`/${subButtonLink}`}

                                    onClick={
                                            TestLink != "" && TestLink != null
                                                ? () => handleNavigete(TestLink)
                                                : () => handleSub(subButtonLink)
                                        }

                                    rel="noopener noreferrer"
                                >
                                    <span className="home-slider-sun-box-a-text">{subButton}</span>
                                    <span className="home-slider-sun-box-a-icon">
                                       {!ButtonLoad &&  <FontAwesomeIcon  className="icc" icon={faArrowRight}   />}
                                    </span>

                                    {ButtonLoad && <img src={buttonloader} alt="Loading" /> }
                                </a>
                            ):(

                                  <a 
                                    className="home-slider-sun-box-a"
                                    onClick={()=>LoginShowSub(subButtonLink)} >

                                      <span className="home-slider-sun-box-a-text">{subButton}</span>
                                    <span className="home-slider-sun-box-a-icon">
                                        <FontAwesomeIcon  className="icc" icon={faArrowRight} />
                                    </span>
                                </a>

                            )}

                                </div>
                            </div>




                        </div>
                    </div>
                </div>
               
            </div>
        </div>

           {ShowModal && (
                                            
                  <div 
                  className={`newdashpop-overlay subs-cognit-modal1 modal_subcript test ${
                   subscription?.data?.length == 1 ? "single-subscription" : ""
                  }`}
                
                >

                    <div className="newdashpop-inner">

                        <div className="newdashpop-container">

                            <button
                                className="newdashpop-close"
                                onClick={() => setShowModal(false)}
                                >
                                &times;
                            </button>

                            <div className="conent-pop">
                            
                            <Subscriptions subs={subS} userdetail={userdetail} Subcription={subscription} onLoginChange={onLoginChange}/>

                            </div>

                        </div>

                    </div>

                </div>
            )}

        </>

      )

    );
}

export default ResultPageLast;
